import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { cleanDescription } from '@app/core/helpers/common.helper';

/**
 * Sanitizes untrusted HTML before binding with [innerHTML].
 * Returns a plain string so Angular's built-in [innerHTML] sanitization remains active.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): string {
    const normalized = cleanDescription(value);
    return this.sanitizer.sanitize(SecurityContext.HTML, normalized) ?? '';
  }
}
